<div class="upload-control centered-row-container clickable position-rel {{widthHeight}}"
    *ngVar="imgSnippet || oldImgSrc as showImg" (click)="emulateInputClick()">
    <img #logo *ngIf="showImg" class="max-size-inside-parent"
        [src]="imgSnippet ? imgSnippet.src : oldImgSrc" (error)="logo.src=errorImageLink">
    <div *ngIf="!showImg"
        class="centered-column-container column-gap-1">
        <div>
            <app-all-icons
             [iconNameAndStyling]="'upload.svg; icon-size-2; opacity0p5'">
            </app-all-icons>    
        </div>
        <span class="font-3  text">
      Upload avatar
    </span>
    </div>
    <app-delete-button *ngIf="showImg" class="position-abs icon-background-hover delete-button"
        (click)="$event.stopPropagation(); deleteClicked()">
    </app-delete-button>
</div>

<input *ngIf="inputSwitcher" #imageInput hidden type="file" accept="image/*" (change)="processFile(imageInput)">
<input *ngIf="!inputSwitcher" #imageInput hidden type="file" accept="image/*" (change)="processFile(imageInput)">